// extracted by mini-css-extract-plugin
export default {"body":"Non_body__Yt3Hy"};